import React from 'react';
import { Link } from 'react-router-dom';
import './Legal.css';

const PrivacyPolicy = () => {
  return (
    <div className="legal-page">
      <div className="container">
        <h1>Politique de Confidentialité</h1>
        <div className="legal-content">
          <p>Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}</p>
          
          <h2>1. Introduction</h2>
          <p>Chez NaturoBooK, nous accordons une importance majeure à la protection de vos données personnelles. Cette politique de confidentialité décrit comment nous collectons, utilisons et protégeons vos informations lorsque vous utilisez notre plateforme.</p>
          
          <h2>2. Données collectées</h2>
          <p>Nous collectons les types de données suivants :</p>
          <ul>
            <li><strong>Données d'identification</strong> : nom, prénom, adresse email, numéro de téléphone</li>
            <li><strong>Données de rendez-vous</strong> : dates, heures, types de services, praticiens</li>
            <li><strong>Données de connexion</strong> : adresse IP, type de navigateur, pages visitées</li>
            <li><strong>Pour les praticiens</strong> : informations professionnelles, adresse du cabinet, spécialités</li>
          </ul>
          
          <h2>3. Finalités du traitement</h2>
          <p>Nous utilisons vos données personnelles aux fins suivantes :</p>
          <ul>
            <li>Création et gestion de votre compte utilisateur</li>
            <li>Traitement des réservations de rendez-vous</li>
            <li>Envoi de notifications concernant vos rendez-vous (confirmations, rappels, annulations)</li>
            <li>Amélioration de nos services et analyse statistique</li>
          </ul>
          
          <h2>4. Fondements juridiques du traitement</h2>
          <p>Le traitement de vos données est fondé sur :</p>
          <ul>
            <li>Votre consentement</li>
            <li>L'exécution du contrat de service</li>
            <li>Notre intérêt légitime à améliorer nos services</li>
            <li>Le respect de nos obligations légales</li>
          </ul>
          
          <h2>5. Destinataires des données</h2>
          <p>Les données peuvent être partagées avec :</p>
          <ul>
            <li>Les praticiens avec lesquels vous prenez rendez-vous</li>
            <li>Nos sous-traitants techniques (hébergement, emails) qui agissent selon nos instructions</li>
            <li>Les autorités légales en cas d'obligation légale</li>
          </ul>
          
          <h2>6. Durée de conservation</h2>
          <p>Nous conservons vos données :</p>
          <ul>
            <li>Données de compte : pendant la durée de votre inscription, puis 3 ans après votre dernière activité</li>
            <li>Données de rendez-vous : 3 ans à compter de la date du rendez-vous</li>
            <li>Données de connexion : 1 an</li>
          </ul>
          
          <h2>7. Sécurité des données</h2>
          <p>Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données contre les accès non autorisés, la perte ou l'altération, notamment :</p>
          <ul>
            <li>Chiffrement des données sensibles</li>
            <li>Authentification à deux facteurs pour les accès administratifs</li>
            <li>Sauvegardes régulières</li>
            <li>Formation de notre personnel aux bonnes pratiques de sécurité</li>
          </ul>
          
          <h2>8. Vos droits</h2>
          <p>Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez des droits suivants :</p>
          <ul>
            <li>Droit d'accès à vos données</li>
            <li>Droit de rectification des données inexactes</li>
            <li>Droit à l'effacement (droit à l'oubli)</li>
            <li>Droit à la limitation du traitement</li>
            <li>Droit à la portabilité des données</li>
            <li>Droit d'opposition au traitement</li>
            <li>Droit de retirer votre consentement à tout moment</li>
          </ul>
          <p>Pour exercer ces droits, contactez-nous à contact@naturobook.fr.</p>
          
          <h2>9. Cookies et technologies similaires</h2>
          <p>Nous utilisons des cookies et technologies similaires pour :</p>
          <ul>
            <li>Assurer le bon fonctionnement de la plateforme</li>
            <li>Mémoriser vos préférences</li>
            <li>Analyser l'utilisation de notre site</li>
          </ul>
          <p>Vous pouvez configurer votre navigateur pour refuser les cookies, mais certaines fonctionnalités du site peuvent alors ne plus être accessibles.</p>
          
          <h2>10. Transfert de données hors UE</h2>
          <p>Nous pouvons transférer vos données à des sous-traitants situés hors de l'Union Européenne. Dans ce cas, nous nous assurons que ces transferts sont encadrés par des garanties appropriées conformément au RGPD.</p>
          
          <h2>11. Modification de la politique de confidentialité</h2>
          <p>Nous nous réservons le droit de modifier cette politique de confidentialité. La date de dernière mise à jour figurant en haut de cette page sera alors modifiée.</p>
          
          <h2>12. Contact</h2>
          <p>Pour toute question concernant notre politique de confidentialité, vous pouvez nous contacter à contact@naturobook.fr.</p>
          <p>Si vous estimez, après nous avoir contactés, que vos droits ne sont pas respectés, vous pouvez adresser une réclamation à la CNIL (www.cnil.fr).</p>
        </div>
        
        <div className="legal-navigation">
          <Link to="/terms-of-service" className="btn btn-outline">Voir les Conditions d'Utilisation</Link>
          <Link to="/" className="btn btn-primary">Retour à l'accueil</Link>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;